export const TOPIC_NAMES = {
  CLOSE_COPILOT: 'CLOSE_COPILOT',
  COLLABORATE_COPILOT_ACTON: 'COLLABORATE_COPILOT_ACTON',
  COLLABORATE_COPILOT_GET_CONTEXT: 'COLLABORATE_COPILOT_GET_CONTEXT',
  COLLABORATE_COPILOT_SET_CONTEXT: 'COLLABORATE_COPILOT_SET_CONTEXT',
  COLLABORATE_PARENT_APP_MESSAGE: 'COLLABORATE_PARENT_APP_MESSAGE',
  COPY_LAST_RESPONSE: 'COPY_LAST_RESPONSE',
  EXPAND_COLLAPSE: 'EXPAND_COLLAPSE',
  FOCUS_INPUT: 'FOCUS_INPUT',
  LAUNCH_FROM_COPILOT_PREVIEW: 'LAUNCH_FROM_COPILOT_PREVIEW',
  LAUNCH_WITH_CUSTOM_COPILOT: 'LAUNCH_WITH_CUSTOM_COPILOT',
  OPEN_PROMPT_TEMPLATE: 'OPEN_PROMPT_TEMPLATE',
  OPEN_ACTION_FORM: 'OPEN_ACTION_FORM',
  OPEN_COPILOT: 'OPEN_COPILOT',
  OPEN_THREAD: 'OPEN_THREAD',
  PROMPT_USER_FOR_MORE_INFO: 'PROMPT_USER_FOR_MORE_INFO',
  SEND_ACTION: 'SEND_ACTION',
  SEND_BREEZE_ACTION: 'SEND_BREEZE_ACTION',
  SEND_MESSAGE: 'SEND_MESSAGE',
  START_NEW_CHAT: 'START_NEW_CHAT',
  COMPOSABLE_UI_ACTION_CLICKED: 'COMPOSABLE_UI_ACTION_CLICKED',
  ADD_STARTER_ACTIONS: 'ADD_STARTER_ACTIONS',
  OPEN_BREEZE_EMAIL_SUPPORT_MODAL: 'OPEN_BREEZE_EMAIL_SUPPORT_MODAL',
  OPEN_BREEZE_IMAGE_LIGHTBOX_MODAL: 'OPEN_BREEZE_IMAGE_LIGHTBOX_MODAL',
  OPEN_BREEZE_CHAT_SUPPORT_MODAL: 'OPEN_BREEZE_CHAT_SUPPORT_MODAL',
  SUBMIT_BREEZE_EMAIL_SUPPORT: 'SUBMIT_BREEZE_EMAIL_SUPPORT',
  SUBMIT_BREEZE_CHAT_SUPPORT: 'SUBMIT_BREEZE_CHAT_SUPPORT'
};